import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { List, Map } from 'immutable';

import { ImmutableMap, Optional, RenderedMessage } from './utils'
import * as game from './game';
import { LEVELS } from './levels';
import * as controls from './controls';


type PlayingState = ImmutableMap<{
  level: number,
  playerId: number | null,
  state: game.GameState,
}>;

function main() {
  // if (!localStorage.getItem('hasPlayed')) { screen = 'controls'; }
  // localStorage.setItem('hasPlayed', 'true');
  let show_screen = 'main';
  let solved_to = parseInt(localStorage.getItem('solved_to') || '0');
  // let solved_to = LEVELS.length - 1;
  function reset_playing_state_for_level(level: number): PlayingState {
    let state = LEVELS[level].get('initial_state');
    let playerId = 0;
    return Map({ level, playerId, state });
  }
  let playing_state: PlayingState = reset_playing_state_for_level(
    localStorage.getItem('level') ? parseInt(localStorage.getItem('level') as string) :
      (solved_to >= LEVELS.length) ? 0 : solved_to
  );
  let current_index = 0;
  localStorage.setItem('level', playing_state.get('level').toString());
  let hist = List<PlayingState>([playing_state]);
  let err: Optional<Error> = null;
  let msg: Optional<RenderedMessage> = null;
  let extra_div: React.ReactElement | null = null;
  let won = false;
  let victory = false;

  LEVELS.forEach((level, i) => {
    console.log('----', i, '.', level.get('name'), '----');
    console.log(level.get('flavor_text'));
  })

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  function rerender() {
    let state = playing_state.get('state');
    let level = LEVELS[playing_state.get('level')];
    localStorage.setItem('level', playing_state.get('level').toString());
    won = game.isWon(state);
    if (won)  {
      solved_to = Math.max(playing_state.get('level')+1, solved_to);
      localStorage.setItem('solved_to', solved_to.toString());
      victory = true;
    }

    // try swap to an existing player if none is currently selected
    let existing_players = game.existingPlayers(state).toArray()
    if ((existing_players.indexOf(playing_state.get('playerId') as number) === -1) && (existing_players.length > 0)) {
        playing_state = playing_state.set('playerId', existing_players[0]);
        // update_playing_state(playing_state);
    }

    let main_app: React.ReactElement;
    if (show_screen === 'levels') {
      main_app = <React.Fragment>
        {
          LEVELS.map((level, i) => {
            // let help_display = level.get('level_help')(state);
            let help_display: Array<React.ReactElement> = [];
            if (i === solved_to + 1) {
              return <h4 className="warning"> Remaining levels locked </h4>
            } else if (i > solved_to) {
              return null;
            }
            return (
              <div key={i} style={{cursor: 'pointer', marginTop: '2em'}} onClick={() => {
                show_screen = 'main';
                playing_state = reset_playing_state_for_level(i);
                update_playing_state(playing_state);
                rerender();
              }}>
                <App
                  level_plain={true}
                  level_header={
                    // playing_state.get('level') + '. ' + level.get('name')
                    level.get('name')
                  }
                  level_victory={level.get('flavor_text')}
                  level_help={help_display}
                  level_render_classes={level.get('render_classes')}
                  extra_div={extra_div}
                  state={level.get('initial_state')} activePlayer={0} err={err}
                  victory={solved_to > i} show_screen={'main'}
                  msg={msg}
                />
              </div>
            )
          })
        }
      </React.Fragment>;
    } else {
      let help_display: Array<React.ReactElement | string> = level.get('level_help')(state);
      main_app = (
        <div onClick={() => {show_screen = 'main'; rerender()}}>
          <App
            level_header={
              // playing_state.get('level') + '. ' + level.get('name')
              level.get('name')
            }
            level_victory={level.get('flavor_text')}
            level_help={help_display}
            level_render_classes={level.get('render_classes')}
            extra_div={extra_div}
            state={state} activePlayer={playing_state.get('playerId')} err={err}
            victory={victory} show_screen={show_screen}
            msg={msg}
          />
        </div>
      )
    }

    root.render(<React.StrictMode>
      <div onClick={() => {show_screen = 'main'; rerender()}}>
          <h2 className="game-title" >
            THE W
            <img src={process.env.PUBLIC_URL + '/img/bird-right-head.png'} alt="bird" style={{position: 'absolute', height: '0.9em', marginLeft: '-0.1em', marginTop: '0.1em'}}/>
            {game.display_wormhole_out(game.wormhole_colors[0], 0, true, {'width': '0.9em', 'height': '0.9em', 'borderWidth': '0.1em', 'margin': 0})}
            RMH
            <img src={process.env.PUBLIC_URL + '/img/bird-right-body.png'} alt="bird" style={{position: 'absolute', height: '0.9em', marginLeft: '-0.1em', marginTop: '0.1em'}}/>
            {game.display_wormhole_in(game.wormhole_colors[0], 0, {'width': '0.9em', 'height': '0.9em', 'borderWidth': '0.1em', 'margin': 0})}
            LE GETS
            <br/>
            THE BIRD EARLY
          </h2>
      </div>

      <div style={{
        position: 'absolute', top: '10px', right: '10px'
      }}>
        <div className="menubutton" onClick={() => {show_screen = 'levels'; rerender()}}>
          Levels
        </div>
        <div className="menubutton" onClick={() => {show_screen = 'controls'; rerender()}}>
          Controls
        </div>
        <div className="menubutton" onClick={() => {show_screen = 'about'; rerender()}}>
          About
        </div>
        <div className="menubutton" onClick={() => {show_screen = 'credits'; rerender()}}>
          Credits
        </div>
      </div>

      {main_app}

    </React.StrictMode>);

  }
  rerender()

  function handleAction(action: game.Action): [Optional<game.GameState>, Optional<RenderedMessage>] {
    try {
      return game.tryAction(playing_state.get('state'), action);
    } catch (e) {
      err = e as Error;
      return [null, null];
    }
  }

  function handleMove(direction: string): [Optional<game.GameState>, Optional<RenderedMessage>] {
    if (playing_state.get('playerId') === null) {
      return [null, <React.Fragment>No players found!  Use <kbd>{controls.wait.main}</kbd> to wait.</React.Fragment>];
      // return handleAction(Map({type: 'wait'}));
    }
    return handleAction(Map({type: 'move', playerId: playing_state.get('playerId'), direction}));
  }

  function update_playing_state(playing_state: PlayingState) {
    hist = hist.slice(0, current_index + 1).push(playing_state);
    current_index = hist.size - 1;
  }

  (window as any).cheat = (speed: number | null) => {
    playing_state = reset_playing_state_for_level(playing_state.get('level'));
    update_playing_state(playing_state);
    let level = LEVELS[playing_state.get('level')];
    let sol = level.get('solution');
    if (sol === null) {
      msg = `No solution for level ${level.get('name')}`;
      rerender();
      return;
    }
    let n = sol.size;
    function play_solution(i: number) {
      if (i >= n) {
        return;
      }
      let action = (sol as List<game.Action>).get(i) as game.Action;
      console.log(action.toJS())
      let [new_state, err] = handleAction(action);
      if (err) {
        msg = err;
        console.log('error', i, 'of', n)
        rerender();
        return;
      }
      if (new_state === null) {
        console.log('error', i, 'of', n)
        msg = `Invalid action: ${action}`;
        rerender();
        return;
      }
      playing_state = playing_state.set('state', new_state);
      update_playing_state(playing_state);
      rerender();
      setTimeout(() => play_solution(i+1), speed || 200);
    }
    play_solution(0);
  }

  (window as any).cheat_all = () => {
    localStorage.setItem('solved_to', LEVELS.length.toString());
  }

  function* keyHandler(): Generator<boolean, void, KeyboardEvent> {
    let handled = false;
    let key_seq = [] // just a convenience for grabbing solutions
    while (true) {
      let e = yield handled;
      handled = false;
      if (e.key === 'Shift') { continue; }
      // console.log(e.key)
      msg = null;
      err = null;
      let matched_control = controls.match_key(e.key);
      // if (matched_control === controls.menu_about) {
      //   show_screen = 'about';
      //   continue;
      // }
      if (show_screen !== 'main') {
        show_screen = 'main';
        continue;
      } else {
        if (matched_control === controls.up) {
          key_seq.push('u')
        } else if (matched_control === controls.down) {
          key_seq.push('d')
        } else if (matched_control === controls.left) {
          key_seq.push('l')
        } else if (matched_control === controls.right) {
          key_seq.push('r')
        } else if (matched_control === controls.wait) {
          key_seq.push(' ')
        } else if (matched_control === controls.borrow) {
          key_seq.push('(c????)')
        } else if (matched_control === controls.reset) {
          key_seq = []
        } else if (matched_control === controls.undo) {
          key_seq.pop()
        }
        console.log(key_seq.join(''))
      }
      if (victory
          && matched_control !== controls.level_back
          && matched_control !== controls.level_back_cheat
          && matched_control !== controls.undo
         ) {
        victory = false;
        let cur_level_i = playing_state.get('level');
        if (cur_level_i < LEVELS.length - 1) {
          cur_level_i++;
        } else {
          cur_level_i = 0;
        }
        playing_state = reset_playing_state_for_level(cur_level_i);
        update_playing_state(playing_state);
        continue;
      } else if ((matched_control === controls.undo) && current_index > 0) {
        current_index--;
        let res = hist.get(current_index);
        if (res === undefined) {
          throw new Error(`undefined history at ${current_index}`);
        }
        playing_state = res;
        victory = false;
        continue;
      } else if ((matched_control === controls.redo) && (current_index < hist.size - 1)) {
        current_index++;
        let res = hist.get(current_index);
        if (res === undefined) {
          throw new Error(`undefined history at ${current_index}`);
        }
        playing_state = res;
        continue;
      } else if (won) {
        // if (cur_level_i < LEVELS.length - 1) {
        playing_state = reset_playing_state_for_level((playing_state.get('level') + 1) % LEVELS.length);
        update_playing_state(playing_state);
        continue;
      } else if (matched_control === controls.control_menu) {
        show_screen = 'controls';
        continue;
      } else if (matched_control === controls.about_menu) {
        show_screen = 'about';
        continue;
      } else if (matched_control === controls.credits_menu) {
        show_screen = 'credits';
        continue;
      } else if (matched_control === controls.levels_menu) {
        show_screen = 'levels';
        continue;
      } else if ((matched_control === controls.level_back) || (matched_control === controls.level_back_cheat)) {
        let cur_level_i = playing_state.get('level');
        if (victory) { 
          victory = false; 
          playing_state = reset_playing_state_for_level(cur_level_i);
          update_playing_state(playing_state);
          continue; 
        }
        if (cur_level_i > 0) {
          cur_level_i--;
        } else if (solved_to > LEVELS.length - 1 || (matched_control === controls.level_back_cheat)) {
          cur_level_i = LEVELS.length - 1;
        } else {
          continue;
        }
        victory = false; // don't show victory screens when going to previous levels
        // victory = true;
        playing_state = reset_playing_state_for_level(cur_level_i);
        update_playing_state(playing_state);
        continue;
      } else if (matched_control === controls.level_next_cheat) {
        victory = true;
        solved_to = Math.max(playing_state.get('level')+1, solved_to);
        localStorage.setItem('solved_to', solved_to.toString());
        continue;
      } else if (matched_control === controls.level_next) {
        let cur_level_i = playing_state.get('level');
        if (solved_to > cur_level_i) {
          // victory = true;
          if (cur_level_i < LEVELS.length - 1) {
            cur_level_i++;
          } else {
            cur_level_i = 0;
          }
          playing_state = reset_playing_state_for_level(cur_level_i);
          update_playing_state(playing_state);
        } else {
          msg = <div>Level unsolved.  <kbd>{controls.level_next_cheat.main}</kbd> to skip</div>
        }
        continue;
      } else if (matched_control === controls.cycle_player) {
        let existing_players = game.existingPlayers(playing_state.get('state'))
        let playerId: number | null = null;
        if (existing_players.size === 0) {
          playerId = null;
        } else {
          let next_i = (existing_players.indexOf(playing_state.get('playerId') as number) + 1) % existing_players.size;
          playerId = existing_players.get(next_i) as number;
        }
        console.log('cycled to', playerId);
        playing_state = playing_state.set('playerId', playerId);
        update_playing_state(playing_state);
        handled = true;
        continue;
      } else if (matched_control === controls.reset) {
        playing_state = reset_playing_state_for_level(playing_state.get('level'));
        update_playing_state(playing_state);
        continue;
      }

      let new_state: Optional<game.GameState> = null;
      if (matched_control === controls.up) {
        [new_state, msg] = handleMove('up');
        handled = true;
      } else if (matched_control === controls.down) {
        [new_state, msg] = handleMove('down');
        handled = true;
      } else if (matched_control === controls.left) {
        [new_state, msg] = handleMove('left');
        handled = true;
      } else if (matched_control === controls.right) {
        [new_state, msg] = handleMove('right');
        handled = true;
      } else if (matched_control === controls.borrow) {
        let state = playing_state.get('state');
        let creatable = game.creatables(state);
        let neg_wormholes = (game.allItems(state).filter(
          item => game.getItemType(item) === 'wormholeOut'
        ) as List<game.WormholeOut>).filter(
          (item: game.WormholeOut) => {
            return (state.getIn(['wormholes', item.get('id'), 'outs', item.get('out_id'), 'delta_t']) as number) < 0
          }
        );
        // let neg_wormholes = state.get('wormholes').filter((wormhole: game.WormholeState, id: number) => {
        //   return wormhole.get('outs').find((out: game.WormholeOutState) => out.get('delta_t')  < 0) !== undefined;
        // }).keySeq().toList().sort();
        if (!neg_wormholes.size) {
          msg = 'No wormhole exits from the future';
          continue;
        }
        let chosen_out: game.WormholeOut;
        if (neg_wormholes.size === 1) {
          chosen_out = neg_wormholes.first() as game.WormholeOut;
        } else {
          let keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'a', 'b', 'c', 'd'];
          extra_div = <div>
            <h5>Where to enter?</h5>
            {neg_wormholes.map((w, i) => <div key={i}>
              <div onClick={() => {
                /* TODO */
              }}>
              {keys[i]}. <div className="cell" style={{backgroundColor: 'transparent'}}>
                <div className="wormholeOut" style={{borderColor: game.wormhole_colors[w.get('id')], width:'100%', height:'100%'}}>
                </div>
              </div>
              </div>
            </div>)}
          </div>;
          e = yield true;
          extra_div = null;
          try {
            chosen_out = neg_wormholes.get(keys.indexOf(e.key)) as game.WormholeOut;
          } catch (err) {
            msg = `Invalid selection ${e.key}`;
            continue;
          }
        }
        extra_div = <div>
          <h5>What exits through the wormhole?</h5>
          {creatable.map((t, i) => <div key={i}>
            <div onClick={() => {
              /* TODO */
            }}>
            {i+1}.
            <div  style={{display: 'inline-block', height: '1em', width: '1em'}}>
              {game.item_display(state, t, {})}
            </div>
            </div>
          </div>)}
        </div>;
        e = yield true;
        extra_div = null;
        let i: number = parseInt(e.key); // can actually be NaN, this is a lie
        let create_item: game.Item = creatable.get(i - 1) as game.Item;
        if (!create_item) {
          msg = `Invalid selection ${e.key}`;
          continue;
        }
        console.log('chosen out', chosen_out)
        let wormhole_id = chosen_out.get('id');
        let wormhole_out_id = chosen_out.get('out_id');
        let direction: Optional<game.Direction> = null;
        let location: game.Location = state.getIn(['wormholes', wormhole_id, 'outs', wormhole_out_id, 'location']) as game.Location;
        let items = game.getCell(state.get('grid'), location).get('items');
        if (items.find(item => {
          // seeing if each item gets pushed
          if (!game.pushable(item)) { return false; }
          if (game.getItemType(item) === 'wormholeOut') {
            let wh = item as game.WormholeOut;
            if ((wh.get('id') === chosen_out.get('id')) && (wh.get('out_id') === chosen_out.get('out_id'))) {
              // we are coming out of this wormhole
              return false;
            }
          }
          return true;
        })) { // || game.getItemType(create_item) === 'player') {
          extra_div = <div>
            <h5>What direction to enter?</h5>
          </div>;
          e = yield true;
          extra_div = null;
          direction = (({w: 'up', a: 'left', s: 'down', d: 'right', ArrowUp: 'up', ArrowDown: 'down', ArrowLeft: 'left', ArrowRight: 'right'}[e.key]) || null) as Optional<game.Direction>;
          if (!direction) {
            msg = `Invalid selection ${e.key}`;
            continue;
          }
        }
        [new_state, msg] = handleAction(Map({
          type: 'enter', item: create_item, wormhole_id: wormhole_id, wormhole_out_id: wormhole_out_id, direction: direction, display_direction: direction || chosen_out.get('default_direction')
        }))
      } else if (matched_control === controls.wait) {
        [new_state, msg] = handleAction(Map({type: 'wait'}));
        handled = true;
      } else {
        continue;
      }
      if (msg === null) {
        if (new_state === null) {
          continue;
        }
        playing_state = playing_state.set('state', new_state);
        (window as any).state = new_state;
        let cur_player = playing_state.get('playerId');
        if (new_state.getIn(['players', cur_player, 'location']) === null || cur_player === null) {
          let existing_players = game.existingPlayers(new_state);
          let new_p: number | null = null;
          if (existing_players.size > 0) {
            new_p = existing_players.first();
          }

          playing_state = playing_state.set('playerId', new_p);
        }
        update_playing_state(playing_state);
      }
    }
  }

  const handler = keyHandler();
  handler.next()
  document.addEventListener('keydown', (e) => {
    let res = handler.next(e).value;
    rerender();
    if (res) { 
      e.preventDefault();
    }
    return !res;
  });
}
main()
